module.exports = __webpack_public_path__ + "static/media/brainflix-combined-2-macbook.c512590a.png";